import * as React from 'react';

import {ButtonGroup} from 'shells/button-group/button-group';

import {AnalyticsStatusButton} from '../../../../email-marketing/analytics/report/analytics-status/analytics-status-button';
import {RouteContext} from '../../../../route-context';

import {EnableChatSwitch} from './enable-chat-switch';
import {TestChatbotButton} from './test-chatbot-button';

export function ChatSettingsHeaderButtons() {
    const {isEmbedded} = React.useContext(RouteContext);

    return (
        <ButtonGroup spacing={16}>
            <EnableChatSwitch />
            {!isEmbedded && <AnalyticsStatusButton pageType='chat' />}
            <TestChatbotButton />
        </ButtonGroup>
    );
}
